function setOverwriteAttributes(attributeId, value, productId = null) {
	$.ajax({
		url: '/ajax/setOverwriteAttributes',
		type: 'post',
		data: {
			"attributeId": attributeId,
			"value": value,
			"productId": productId
		}
	}).done(function (resp) {
		_checkboxCalloutHandler($('.js-ajax-checkbox-alert-container'), resp);
	})
}

function _checkboxCalloutHandler(container, resp) {
	container.append(_createCallout(resp));
	container.fadeIn(500, function() {
		setTimeout(function () {
			container.fadeOut(500, function () {
				container.children().first().remove();
			});
		}, 5000);
	})
}

function _createCallout(resp) {
	let html = `${resp}`;

	return html;
}

export function checkboxHandler() {
	$('body').on('change', '.js-attribute-checkbox', function () {
		let checkbox = $(this);

		const attributeCheckboxes = $('input[type="checkbox"][data-attribute-checkbox]');

		if (typeof checkbox.data('attribute-checkbox') !== 'undefined') {

			var attributeId = checkbox.data('attribute-checkbox');
			var attributeValue = 0;
			var productId = $('input[type="checkbox"][data-product]').val();

			if (checkbox.prop('checked')) {
				attributeValue = checkbox.val();
			}

			setOverwriteAttributes(attributeId, parseInt(attributeValue), parseInt(productId));
		}
	});
}



// WEBPACK FOOTER //
// ./resources/assets/js/contentElements/checkboxHandler.js